export default __webpack_public_path__ + "static/media/plus-icon-theme.a751ae39.svg";